import { Component, inject, OnInit } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MAT_DIALOG_DATA, MatDialogActions, MatDialogContent, MatDialogRef, MatDialogTitle } from '@angular/material/dialog';
import { TranslatePipe } from '@ngx-translate/core';

@Component({
  selector: 'app-confirm-not-all-players',
  imports: [TranslatePipe, MatDialogTitle, MatDialogContent, MatDialogActions,MatButtonModule],
  templateUrl: './confirm-not-all-players.html',
  styleUrl: './confirm-not-all-players.scss'
})
export class ConfirmNotAllPlayers implements OnInit{
  readonly dialogRef = inject(MatDialogRef<ConfirmNotAllPlayers>);
  data = inject(MAT_DIALOG_DATA);

  ngOnInit(): void {
    this.dialogRef.disableClose = true;
  }

  onNoClick(value: boolean = false): void {
    this.dialogRef.close(value);
  }

  clickIconClose(event: MouseEvent){
    //if(event.layerX > 390 && event.layerX < 417 && event.layerY > 15 && event.layerY < 40){ 
      this.onNoClick();
    //}
  }

}
